import React from 'react';
import PropTypes from 'prop-types';
import { get, assign } from 'lodash';
import CleaningFeeForm from './forms/CleaningFeeForm';
import { FormattedMessage } from 'react-intl';
import SharedIntlProviderHOC from '../shared-components/hocs/sharedIntlProviderHOC';

const CleaningFee = ({ listing, ...props }) => {
  const cleaningFee = get(listing, 'cleaning_fee', {});
  const { value, obj_state = 'DEACTIVATED', ...rest } = cleaningFee;
  const initialValues = { cleaning_fee: assign({}, rest, { value: value || null }, { obj_state }) };
  const zendeskLocale = SharedIntlProviderHOC.getZendeskLocale();

  return (
    <div className="margin-xl-top">
      <h4><FormattedMessage id="hosting.cleaning_fee.heading" defaultMessage="Cleaning Fee"/></h4>
      <p className="text-small text-gray-dark"><FormattedMessage id="hosting.cleaning_fee.cleaning_text" defaultMessage="You are responsible for cleaning after each booking. You can charge a fee to cover related costs. {link}" values={{ link: <a href={`https://support.peerspace.com/hc/${zendeskLocale}/articles/115002220303`}><FormattedMessage id="hosting.cleaning_fee.learn_more_link_text" defaultMessage="Learn more"/></a> }}/></p>
      <div className="clearfix" />
      <div className="row margin-lg-top margin-md-bottom">
        <div className="col-xs-12">
          <CleaningFeeForm
            {...props}
            listing={listing}
            initialValues={initialValues}
          />
        </div>
      </div>
    </div>
  );
};

CleaningFee.propTypes = {
  listing: PropTypes.object.isRequired
};

export default CleaningFee;
